window.app_models.note = {
    id:null,
    note_type:{
        id: null,
        name: null
    },
    user: {
        name: null
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/note.js